export interface HelpPage {
  slug: string;
  title: string;
  summary?: string;
  fileName: string;
}

export const helpPages: HelpPage[] = [
  {
    slug: "adding-announcement",
    title: "Update your lineup - via announcements",
    summary: "Create announcements to group and schedule new artist drops.",
    fileName: "adding-announcement.html",
  },
  {
    slug: "adding-announcement-bands-1",
    title: "Add bands to your announcement #1",
    summary: "Add bands to your announcements - method 1",
    fileName: "adding-announcement-bands-1.html",
  },
{
    slug: "adding-announcement-bands-2",
    title: "Add bands to your announcement #2",
    summary: "Add bands to your announcements - method 2",
    fileName: "adding-announcement-bands-2.html",
  },
  {
    slug: "adding-bands",
    title: "Adding bands",
    summary: "Add a new band and upload their press images.",
    fileName: "adding-bands.html",
  },
  {
    slug: "adding-information",
    title: "Adding information pages",
    summary: "Publish practical information for attendees inside the app.",
    fileName: "adding-information.html",
  },
  {
    slug: "adding-links",
    title: "Adding links",
    summary: "Manage external links that surface throughout the app.",
    fileName: "adding-links.html",
  },
  {
    slug: "adding-menu-links",
    title: "Adding menu links",
    summary: "Control which links appear in the app navigation.",
    fileName: "adding-menu-links.html",
  },
  {
    slug: "adding-news",
    title: "Adding news",
    summary: "Create news posts and keep fans up to date.",
    fileName: "adding-news.html",
  },
  {
    slug: "adding-polls",
    title: "Adding polls",
    summary: "Set up polls to collect quick attendee feedback.",
    fileName: "adding-polls.html",
  },
  {
    slug: "adding-sponsors",
    title: "Adding sponsors",
    summary: "List partners and sponsors with their branding assets.",
    fileName: "adding-sponsors.html",
  },
  {
    slug: "adding-stages",
    title: "Adding stages",
    summary: "Create and configure stages for your festival schedule.",
    fileName: "adding-stages.html",
  },
  {
    slug: "adding-vendors",
    title: "Adding vendors",
    summary: "Add food or retail vendors with their details.",
    fileName: "adding-vendors.html",
  },
  {
    slug: "setting-live-festival",
    title: "Setting the live festival",
    summary: "Mark which edition is live to power the public app.",
    fileName: "setting-live-festival.html",
  },
];
